<template>
  <AuthForm
    :can-submit="canBeSubmitted"
    :error="form.error"
    :submitted="form.submitted"
    type="options"
    @submit="submit"
  >
    <FormInput
      :label="$t('phone')"
      :model-value="form.fields.phone.value"
      name="phone"
      :placeholder="$t('phone')"
      type="tel"
      @update:modelValue="(newValue) => (form.fields.phone = newValue)"
    />
  </AuthForm>
</template>

<script>
import AuthForm from '@/components/form/auth/AuthForm.vue'
import { FormInput } from '@/components/form/fields'
import { AuthFormCanBeSubmittedMixin } from '@/components/form/mixins'

export default {
  name: 'AuthOptionsForm',
  mixins: [AuthFormCanBeSubmittedMixin],
  components: { FormInput, AuthForm },
  data() {
    return {
      form: {
        error: null,
        fields: {
          phone: {
            valid: false,
            value: null,
          },
        },
        submitted: false,
      },
    }
  },
  methods: {
    async submit() {
      this.form.error = null
      this.form.submitted = true
      const error = await this.$store.dispatch('updateHunter', {
        phone: this.form.fields.phone.value,
      })

      this.form.submitted = false
      this.form.error = error
    },
  },
  watch: {
    'form.fields.phone.value'() {
      this.form.error = null
    },
  },
}
</script>
